import { z } from 'zod';

// Define schema for a single pre_contractual_document
export const PreContractualDocument = z.object({
  id: z.string(),
  display_name: z.string(),
  document_type: z.enum([
    'PRODUCT_INFORMATION_SHEET',
    'PRODUCT_INFORMATION_SHEET_FIRST_ORDER',
    'RENEWAL_PRODUCT_INFORMATION_SHEET',
    'DTB_TERMS_AND_CONDITIONS',
    'TRUSTEE_TERMS_AND_CONDITIONS',
    'GDPR_CONDITIONS',
    'DEPOSIT_GUARANTEE_SCHEME_INFORMATION_SHEET',
    'TERMS_OF_BUSINESS',
    'KEY_INFORMATION_DOCUMENT',
    'COMMON_BOND_CRITERIA',
    'CUSTOMER_DECLARATION',
    'DATA_PROTECTION_POLICY',
    'SUSTAINABILITY_INFORMATION_SHEET',
  ]),
  url: z.string().url(),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

// Define schema for the array of pre_contractual_documents
export const PreContractualDocumentsSchema = z.array(PreContractualDocument);
